import CONFIG from '../common/config'
import { login } from './hybrid'
import { Dialog } from 'vant'
/**
 * 页面滚动了多少像素
 * @returns {number}
 */
export function getScrollTop() {
	let scrollTop = 0
	if (document.documentElement && document.documentElement.scrollTop) {
		({ scrollTop } = document.documentElement)
	} else if (document.body) {
		({ scrollTop } = document.body)
	}
	return scrollTop
}

/**
 * 是否登录
 * loginFlag: true未登录时调起登录页面，falae不处理
 * return: true 已登录 false: 未登录
 */
export async function isLogin(loginFlag = true) {
	let token = sessionStorage.getItem('token')
	if (!token && loginFlag) {
		const res = await login()
		if (res.code === 200 && res.data && res.data.token) {
			sessionStorage.setItem('token', res.data.token)
			token = res.data.token
		}
	}

	return !!token
}

// 唤起APP
export async function openApp(path) {
	const UA = navigator.userAgent.toLowerCase()
	const isWeiXin = UA.indexOf('micromessenger') !== -1 // 微信
	const isDingTalk = UA.indexOf('dingtalk') !== -1 // 钉钉
	const isQQ = UA.indexOf('qq') !== -1 && UA.indexOf('mqqbrowser') === -1 // QQ
	// const isHarmonyOS = UA.indexOf('HarmonyOS') > -1 // 鸿蒙
	const isAndroid = UA.indexOf('android') > -1 || UA.indexOf('linux') > -1 // 安卓
	const isIOS = !!UA.match(/\(i[^;]+;( u;)? cpu.+mac os x/) // iOS

	if (isWeiXin || isDingTalk || isQQ) {
		return true
	}

	if (isAndroid) {
		// android端
		// 安卓app的scheme协议
		console.log('开始跳转-Android', `${CONFIG.scheme}${path}`)

		window.location.href = `${CONFIG.scheme}${path}`
		setTimeout(() => {
			const { hidden } = window.document

			if (typeof hidden === 'undefined' || hidden === false) {
				// showToolkit.value = false
				// App store下载地址
				Dialog.confirm({
					title: '打开APP遇到问题？',
					message: `当前应用可能不支持唤醒我们的APP，如您未下载${CONFIG.appName}APP，请您点击[去下载]，如您已下载请您点击[手动打开]`,
					messageAlign: "left",
					confirmButtonText: '手动打开',
					confirmButtonColor: '#1d6fe9',
					cancelButtonText: '去下载',
				}).then(() => {
					window.location.href = `${CONFIG.scheme}${path}`
				}).catch(() => {
					window.location.href = CONFIG.AndroidDownload
				})
			}
		}, 2000)
	} else if (isIOS) {
		// ios端
		// ios的scheme协议
		console.log('开始跳转-IOS', `${CONFIG.scheme}${path}`)

		window.location.href = `${CONFIG.scheme}${path}`
		setTimeout(() => {
			const { hidden } = window.document
			if (typeof hidden === 'undefined' || hidden === false) {
				// showToolkit.value = false
				// App store下载地址
				Dialog.confirm({
					title: '打开APP遇到问题？',
					message: `当前应用可能不支持唤醒我们的APP，如您未下载${CONFIG.appName}APP，请您点击[去下载]，如您已下载请您点击[手动打开]`,
					messageAlign: "left",
					confirmButtonText: '手动打开',
					confirmButtonColor: '#1d6fe9',
					cancelButtonText: '去下载',
				}).then(() => {
					window.location.href = `${CONFIG.scheme}${path}`
				}).catch(() => {
					window.location.href = CONFIG.iOSDownload
				})
			}
		}, 5000)
	} else {
		// 检测不到UA信息或PC端，尝试使用android的方式打开
		// 安卓app的scheme协议
		console.log('开始跳转, 其他', `${CONFIG.scheme}${path}`)
		window.location.href = `${CONFIG.scheme}${path}`
		setTimeout(() => {
			const { hidden } = window.document
			if (typeof hidden === 'undefined' || hidden === false) {
				window.location.href = CONFIG.AndroidDownload
			}
		}, 5000)
	}
	return false
}
